export enum StoreKeys {
    Theme = 'Theme',
    Token = 'Token',
    Profile = 'Profile',
    Language = 'Language'
}
